import Detector from '../detector';
// import { Confirm } from '../../components/Confirm';
import { strategyFactory } from './strategy/index';
import zzc from '../../native/zzc';

const IS_LOGIN = 'isLogin';
const GOTO_LOGIN = 'gotoLogin';
const CLEAR_LOGIN = 'clearLogin';

// const location = window.location;


/**
 * 判断登录态
 */
export function isLogin() {
  return safetyUseStrategy(IS_LOGIN);
}

/**
 * 去登录，两个参数暂时只有微信登录需要用到
 * @param {String} params1 微信登录后跳转地址
 * @param {String} params2 跳转形式 _blank - 打开新页面 _self 自刷新
 */
export function gotoLogin(params1, params2) {
  return safetyUseStrategy(GOTO_LOGIN, params1, params2);
}

export function clearLogin() {
  return safetyUseStrategy(CLEAR_LOGIN);
}

/**
 * 登录后的操作
 */
export function handleLogin(callback) {
  if (window.zzc) {
    window.zzc.call('onLoginStatusChange', {
      listener(res) {
        if (res.type === '1') {
          callback();
        }
      }
    });
  }
}

export function handleLogout(callback) {
  if (zzc) {
    zzc.call('onLoginStatusChange', {
      listener(res) {
        if (res.type === '0') {
          callback();
        }
      }
    });
  }
}


/**
 * 自动检查有没有登录，没登录会一直请求登录
 * @param options
 * @returns {boolean} 是否已经登录
 */
export function autoCheckLogin() {
  if (!isLogin()) {
    gotoLogin();
    return false;
  }

  return true;
}

function safetyUseStrategy(methodName, params1, params2) {
  // 网页环境
  const browser = Detector.browser.name;
  // let browser = 'zuzuche';
  return strategyFactory(browser)[methodName](params1, params2);
}
